import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listActiveParties } from '../api/client.js';
import { ACTIVE_PARTIES_QUERY_KEY } from '../api/queryKeys.js';

import type { ActivePartiesResponse } from '@mixwire/contracts';

export const useActiveParties = (isEnabled: boolean): UseQueryResult<ActivePartiesResponse> =>
  useQuery({
    queryKey: ACTIVE_PARTIES_QUERY_KEY,
    queryFn: listActiveParties,
    enabled: isEnabled,
    staleTime: 5000,
  });
